var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmallPlotIcon = function SvgSmallPlotIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.688 8-1.467 1.76a.667.667 0 0 1-.512.24H5.291a.667.667 0 0 1-.512-.24L3.312 8 4.78 6.24A.667.667 0 0 1 5.291 6h5.418c.198 0 .386.088.512.24L12.688 8Zm.868 0 .4.48a1.333 1.333 0 0 1 0 1.707l-2.223 2.667c-.253.304-.628.48-1.024.48H5.291c-.395 0-.77-.176-1.024-.48l-2.222-2.667a1.333 1.333 0 0 1 0-1.707l.4-.48-.4-.48a1.333 1.333 0 0 1 0-1.707l2.222-2.666c.253-.304.629-.48 1.024-.48h5.418c.396 0 .771.176 1.024.48l2.223 2.666a1.333 1.333 0 0 1 0 1.708l-.4.48Zm-.434.521.321.386a.666.666 0 0 1 0 .853l-2.222 2.667a.667.667 0 0 1-.512.24H5.291a.667.667 0 0 1-.512-.24L2.557 9.76a.667.667 0 0 1 0-.853l.322-.386 1.388 1.666c.253.304.629.48 1.024.48h5.418c.396 0 .771-.176 1.024-.48l1.389-1.666ZM2.879 7.48l-.322-.386a.667.667 0 0 1 0-.854l2.222-2.666a.667.667 0 0 1 .512-.24h5.418c.198 0 .386.088.512.24l2.222 2.666a.666.666 0 0 1 0 .854l-.321.386-1.389-1.667a1.333 1.333 0 0 0-1.024-.48H5.291c-.395 0-.77.176-1.024.48L2.88 7.48Z",
    fill: "currentColor"
  })));
};

export default SvgSmallPlotIcon;